import React = require('react');
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import diyLightTheme = require('../../material-ui/diyLightTheme');

import l10n from 'diy/util/l10n';
import StartView from "./views/StartView";
import DisclaimerView from "./views/DisclaimerView";

interface StartDialogProps extends React.Props<StartDialog> {
    className?: string;
    onSubmit: Function;
    onCancel: Function;
    onDisclaimerCancel: Function;
    url: string;
}

interface StartDialogState {
    disclaimer: boolean;
}

export default class StartDialog extends React.Component<StartDialogProps, StartDialogState> {

    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    constructor(props: StartDialogProps) {
        super(props);
        this.state = {
            disclaimer: false
        };
    }

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    render() {
        let actions: JSX.Element[];
        let content: JSX.Element = <div></div>;

        if (this.state.disclaimer) {
            content = <DisclaimerView />;
            actions = [
                <FlatButton
                    label={l10n('migration.dialog.decline')}
                    onTouchTap={this.onDisclaimerCancel} />,
                <RaisedButton
                    primary={true}
                    data-test='start-import'
                    label={l10n('migration.dialog.accept')}
                    onTouchTap={this.onSubmit} />
            ];
        } else {
            content = <StartView url={this.props.url} />;
            actions = [
                <FlatButton
                    label={l10n('migration.dialog.cancel')}
                    onTouchTap={this.onCancel} />,
                <RaisedButton
                    primary={true}
                    data-test='start-import'
                    label={l10n('migration.dialog.submit')}
                    onTouchTap={this.onAccept} />
            ];
        }

        return (
            <Dialog open={true}
                    autoScrollBodyContent={true}
                    className={this.props.className}
                    contentClassName="migration-dialog opening-dialog"
                    bodyClassName="dialog-body"
                    actionsContainerClassName="dialog-actions"
                    actions={actions}
                    style={{zIndex: diy.editor.getNewTopZIndex()}}>
                <div className="dialog-inner">
                    {content}
                </div>
            </Dialog>
        );
    }

    private onSubmit = () => {
        this.props.onSubmit();
    };

    private onAccept = () => {
        this.setState({
            disclaimer: true
        });
    };

    private onCancel = () => {
        this.props.onCancel();
    };

    private onDisclaimerCancel = () => {
        this.props.onDisclaimerCancel();
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/startDialog/StartDialog.tsx
 **/